import React, { useEffect } from "react";
import Banner from "./Components/Banner";
import LiveDemo from "./Components/LiveDemo";
import TrustedBy from "./Components/TrustedBy";
import Maintain from "./Components/Maintain";
import BuiltForHiringTeams from "./Components/BuiltForHiringTeams";
import HowItWorks from "./Components/HowItWorks";
import FAQ from "./Components/FAQ";
import CTA from "./Components/CTA";
import { navItemHighlighter } from "../../Utils/helper";
import { useLocation } from "react-router-dom";

const Home = () => {
  useLocation();
  const href = window.location.href.substring(
    window.location.href.lastIndexOf("#") + 1
  );
  useEffect(() => {
    const element = document.getElementById(href);

    const elementOffset = element?.getBoundingClientRect().top + window.scrollY;
    const isAnotherPage = false;
    navItemHighlighter(isAnotherPage, href);
    if (element) {
      window.scrollTo({
        top: elementOffset - 80,
        left: 0,
        behavior: "smooth",
      });
    }
  }, [href]);
  return (
    <div>
      <Banner />
      <LiveDemo />
      <TrustedBy />
      <Maintain />
      <BuiltForHiringTeams />
      <HowItWorks />
      <FAQ />
      <CTA />
    </div>
  );
};

export default Home;
